import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

function isProfileIncomplete(user) {
  // Only doctors must have specialty + whatsapp; admins are exempt
  if (!user || user.role !== "doctor") return false;
  const specialty = (user.specialty || "").trim();
  const whatsapp = (user.whatsapp || "").trim();
  return !specialty || !whatsapp;
}

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] grid place-items-center">
        <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
          Verifying session…
        </div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  // Force doctor to finish onboarding (specialty + whatsapp) before anything else
  if (isProfileIncomplete(user) && location.pathname !== "/complete-profile") {
    return <Navigate to="/complete-profile" replace />;
  }
  return children;
}
